import { render, staticRenderFns } from "./ScheduledMails.vue?vue&type=template&id=6b37d1d2&scoped=true&"
import script from "./ScheduledMails.vue?vue&type=script&lang=js&"
export * from "./ScheduledMails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b37d1d2",
  null
  
)

export default component.exports